export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-8 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-center">
          <div className="lg:col-span-3">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-2 h-2 rounded-full bg-accent-500"></div>
              <span className="text-xs font-semibold uppercase tracking-[0.2em] text-foreground-500">Verified Buyer Review</span>
            </div>

            <blockquote className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-snug italic">
              <span className="text-primary-500 text-4xl md:text-5xl">&ldquo;</span>
              The Vigorbuy Spreadsheet completely changed how I shop online. Before discovering this resource, I wasted hours comparing products across different sites. Now I get curated lists, QC guides, and direct links all in one place. It is genuinely the best vigorbuy spreadsheet resource available in 2026.
            </blockquote>

            <div className="mt-8 flex items-center gap-4">
              <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center">
                <span className="font-semibold text-secondary-700 text-sm">JK</span>
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-950">James Keller</p>
                <div className="flex items-center gap-1.5 mt-0.5">
                  <span className="text-xs text-foreground-500">Verified Purchase</span>
                  <div className="flex items-center">
                    {[1, 2, 3, 4, 5].map((s) => (
                      <i key={s} className="ri-star-fill text-xs text-accent-500"></i>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Happy%20stylish%20shopper%20in%20warm%20toned%20outfit%20standing%20in%20modern%20bright%20apartment%20with%20fashion%20products%20and%20packages%20around%20candid%20lifestyle%20portrait%20natural%20window%20lighting%20genuine%20expression%20editorial%20photography%20no%20text%20no%20logos&width=600&height=700&seq=vigor-v2-testimonial&orientation=portrait"
                alt="Satisfied Vigorbuy customer"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}